import { render } from "./MainComponent.vue?vue&type=template&id=6d7ad8e4&scoped=true"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=6d7ad8e4&scoped=true&lang=css"

import exportComponent from "D:\\MyProject\\repo\\OlivOS-chat\\olivos-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7ad8e4"]])

export default __exports__